import { ElementState } from "@creatomate/preview";

const getOverlappingElements = (
  element: ElementState,
  placement: { time: number; duration: number },
  elements?: ElementState[]
) => (
  elements?.filter(trackElement => {
    const elementEndTime = trackElement.globalTime + trackElement.duration;
    return elementEndTime > placement.time
      && trackElement.globalTime < (placement.time + placement.duration)
      && element.source.id !== trackElement.source.id;
  })
);

export default getOverlappingElements;
